import _ from 'lodash';

export const toArray = (obj) => {
  if (!obj) {
    return [];
  } else if (obj instanceof Array) {
    return obj;
  }
  return [obj];
};

export const swapKeyValue = (map, allValueIsArray) => {
  const result = {};
  _.forEach(map, (value, key) => {
    const curr = result[value];
    if (allValueIsArray || ((curr !== undefined) && !(curr instanceof Array))) {
      result[value] = toArray(curr);
      result[value].push(key);
    } else if (curr === undefined) {
      result[value] = key;
    } else /* if (curr instanceof Array) */ {
      result[value].push(key);
    }
  });
  return result;
};
